import React from 'react';
import { Paragraph } from '../Typography';
import Location from '../Icons/location';
import CameraBlack from '../Icons/Visio/CameraBlack';

import { mediaQueries } from 'src/style/breakpoints';

/**
 * @type React.FunctionComponent<{ places: string, city: string, address: string, hours: string}>
 */

const FullAddress = ({ place, address, city, hours, title, isOnline }) => {
  return (
    <div
      css={{
        display: 'flex',
        flex: 3,
        flexDirection: 'column',
        [mediaQueries.tabletPortraitUp]: {
          flex: 2,
        },
      }}
    >
      <Paragraph
        css={{
          fontWeight: 'bold',
          padding: 0,
          paddingBottom: 8,
          fontSize: 21,
        }}
      >
        {title}
      </Paragraph>

      {isOnline !== true ? (
        <div css={{ display: 'flex', flexDirection: 'row' }}>
          <div
            css={{
              paddingRight: 16,
              marginTop: 4,
            }}
          >
            <Location />
          </div>

          <div>
            <Paragraph
              css={{
                padding: 0,
                lineHeight: '24px',
                fontSize: 17,
                [mediaQueries.phoneOnly]: {
                  fontSize: 14,
                  lineHeight: '18px',
                },
              }}
            >
              {place}
              <br></br>
              {address}
              <br></br>
              {city}
            </Paragraph>
            <Paragraph
              css={{
                display: 'none',
                [mediaQueries.phoneOnly]: {
                  display: 'flex',
                  fontSize: 12,
                  lineHeight: '20px',
                  padding: '10px 0 0 0',
                },
              }}
            >
              {hours}
            </Paragraph>
          </div>
        </div>
      ) : (
        <div css={{ display: 'flex', flexDirection: 'row', marginTop: 6 }}>
          <div
            css={{
              paddingRight: 16,
            }}
          >
            <CameraBlack />
          </div>

          <div>
            <Paragraph
              css={{
                padding: 0,
                lineHeight: '24px',
                fontSize: 17,
                [mediaQueries.phoneOnly]: {
                  fontSize: 14,
                  lineHeight: '18px',
                },
              }}
            >
              Visio-conférence (via Zoom)
            </Paragraph>
            <Paragraph
              css={{
                display: 'none',
                [mediaQueries.phoneOnly]: {
                  display: 'flex',
                  fontSize: 12,
                  lineHeight: '20px',
                  padding: '10px 0 0 0',
                },
              }}
            >
              {hours}
            </Paragraph>
          </div>
        </div>
      )}
    </div>
  );
};

export default FullAddress;
